import { callNativeAsync, isNativeApp } from "../../../servicos/config/nativeBridge.js"

const DEV_LA = -19.934101
const DEV_LO = -44.157393

function parseLocal(raw) {
	if (raw == null || raw === "") return null
	if (typeof raw === "string") {
		try {
			return JSON.parse(raw)
		} catch {
			return null
		}
	}
	return raw
}

export async function obterPosicaoRotaServicos() {
	if (window.isLocalHost && !isNativeApp()) {
		return { la: DEV_LA, lo: DEV_LO }
	}

	try {
		if (window.AndroidInterface?.getLocation) {
			const raw = await callNativeAsync("getLocation")
			const loc = parseLocal(raw)
			const la = Number(loc?.latitude)
			const lo = Number(loc?.longitude)
			if (Number.isFinite(la) && Number.isFinite(lo) && !(la === 0 && lo === 0)) {
				return { la, lo }
			}
		}
	} catch {
		/* ignore */
	}

	return new Promise((resolve) => {
		if (!navigator?.geolocation?.getCurrentPosition) {
			resolve(null)
			return
		}
		navigator.geolocation.getCurrentPosition(
			(pos) => {
				const la = pos.coords.latitude
				const lo = pos.coords.longitude
				const heading = Number(pos.coords.heading)
				resolve(la || lo
					? { la, lo, heading: Number.isFinite(heading) && heading >= 0 ? heading : null }
					: null)
			},
			() => resolve(null),
			{ enableHighAccuracy: true, timeout: 12000, maximumAge: 5000 }
		)
	})
}

export function abrirGpsNativo(la, lo) {
	if (!Number.isFinite(Number(la)) || !Number.isFinite(Number(lo))) return
	if (window.AndroidInterface?.abrirMaps) {
		window.AndroidInterface.abrirMaps(`${la},${lo}`)
		return
	}
	const url = `https://www.google.com/maps/dir/?api=1&destination=${la},${lo}`
	if (window.AndroidInterface?.redirectLink) {
		window.AndroidInterface.redirectLink(url)
		return
	}
		window.open(url, "_blank", "noopener,noreferrer")
}

function headingDoEvento(e) {
	if (!e) return null
	const webkit = Number(e.webkitCompassHeading)
	if (Number.isFinite(webkit)) return webkit
	if (e.absolute === true && Number.isFinite(Number(e.alpha))) {
		return (360 - Number(e.alpha)) % 360
	}
	if (Number.isFinite(Number(e.alpha))) return (360 - Number(e.alpha)) % 360
	return null
}

function pedirEvento(Ctor) {
	if (!Ctor || typeof Ctor.requestPermission !== "function") return Promise.resolve(true)
	try {
		return Promise.resolve(Ctor.requestPermission())
			.then((r) => r === "granted")
			.catch(() => false)
	} catch {
		return Promise.resolve(false)
	}
}

/**
 * No iOS a bússola do WebView só liga depois de um toque.
 * Precisa ser chamado no mesmo gesto do usuário (click/touch).
 */
export function pedirPermissaoBussola() {
	if (typeof window === "undefined") return Promise.resolve(false)
	return Promise.all([
		pedirEvento(window.DeviceOrientationEvent),
		pedirEvento(window.DeviceMotionEvent),
	]).then((oks) => oks.some(Boolean))
}

/** Bússola do aparelho (mesmo parado). */
export function iniciarBussola(onHeading) {
	if (typeof window === "undefined" || typeof onHeading !== "function") return () => {}
	const ouvir = (e) => {
		const h = headingDoEvento(e)
		if (h == null) return
		onHeading(h)
	}
	const opts = { capture: true }
	window.addEventListener("deviceorientationabsolute", ouvir, opts)
	window.addEventListener("deviceorientation", ouvir, opts)
	return () => {
		window.removeEventListener("deviceorientationabsolute", ouvir, opts)
		window.removeEventListener("deviceorientation", ouvir, opts)
	}
}
